/**
 * @module app.cs
 */

import { autoinject } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class ManageUserDefinedFieldsPage {

    ////****************** Fields and Properties ************************************////
    protected moduleCode = 'CS';

    protected id: guid = guid();
    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly logger: AppLogger) {
        this.logger.source = this;
    }

    ////****************** Element References ***************************************////

    ////****************** Functions ************************************************////

}
